"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _reactI18next = require("react-i18next");
var R = _interopRequireWildcard(require("ramda"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _config = require("../../../../services/config");
var _Button = _interopRequireWildcard(require("../../../ui/Button"));
var _Tooltip = _interopRequireWildcard(require("../../../ui/Tooltip"));
var _Label = _interopRequireDefault(require("../../../ui/Label"));
var _withProps = _interopRequireDefault(require("./withProps"));
var _styles = _interopRequireDefault(require("./styles"));
var _excluded = ["getBackground"];
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
var getExternalProps = function getExternalProps(isSelected) {
  return R.call(R.ifElse(Boolean, function (_ref) {
    var getBackground = _ref.getBackground,
      externalProps = _objectWithoutProperties(_ref, _excluded);
    return _objectSpread({}, externalProps, {
      background: getBackground(isSelected)
    });
  }, R.always({})), (0, _config.getOperatorsControlInSearchForm)());
};
var OperatorsControl = function OperatorsControl(_ref2) {
  var isAllSelected = _ref2.isAllSelected,
    operators = _ref2.operators,
    selectedOperators = _ref2.selectedOperators,
    onAllToggle = _ref2.onAllToggle,
    onToggle = _ref2.onToggle;
  var _useTranslation = (0, _reactI18next.useTranslation)('SEARCH_FORM'),
    t = _useTranslation.t;
  return /*#__PURE__*/_react.default.createElement(_Label.default, {
    clickable: false,
    text: t('OPERATORS_CONTROL_LABEL')
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: _styles.default.checkboxes
  }, /*#__PURE__*/_react.default.createElement(_Button.default, _extends({
    size: _Button.SIZES.TINY,
    theme: isAllSelected ? _Button.THEMES.PURPLE : _Button.THEMES.GRAY,
    onClick: onAllToggle
  }, getExternalProps(isAllSelected)), t('OPERATORS_CHANGE_ALL_BUTTON')), R.map(function (_ref3) {
    var id = _ref3.id,
      includedActiveTransport = _ref3.includedActiveTransport,
      name = _ref3.name;
    var isSelected = R.includes(id, selectedOperators);
    var isDisabled = !isSelected && !includedActiveTransport;
    var buttonJSX = /*#__PURE__*/_react.default.createElement(_Button.default, _extends({
      disabled: isDisabled,
      key: id,
      size: _Button.SIZES.TINY,
      theme: isSelected ? _Button.THEMES.PURPLE : _Button.THEMES.GRAY,
      onClick: function onClick() {
        return onToggle(id);
      }
    }, getExternalProps(isSelected)), name);
    return isDisabled ? /*#__PURE__*/_react.default.createElement(_Tooltip.default, {
      content: t('OPERATORS_CONTROL_DISABLE_OPERATOR'),
      key: id,
      placement: _Tooltip.PLACEMENTS.TOP,
      trigger: [_Tooltip.TRIGGERS.HOVER]
    }, buttonJSX) : buttonJSX;
  }, operators)));
};
OperatorsControl.propTypes = {
  operators: _propTypes.default.arrayOf(_propTypes.default.shape({
    id: _propTypes.default.number.isRequired,
    name: _propTypes.default.string.isRequired,
    includedActiveTransport: _propTypes.default.bool.isRequired
  })).isRequired,
  selectedOperators: _propTypes.default.arrayOf(_propTypes.default.number).isRequired,
  onAllToggle: _propTypes.default.func.isRequired,
  onToggle: _propTypes.default.func.isRequired,
  isAllSelected: _propTypes.default.bool
};
var enhancer = R.compose(_withProps.default, _react.memo);
var _default = exports.default = enhancer(OperatorsControl);